module.exports = __webpack_public_path__ + "static/img/FigmaDDSSlicePNGd563d049f81530d533671079b9a4f602.d563d049.png";